import { render, staticRenderFns } from "./statistics-view.vue?vue&type=template&id=51f53a3a"
import script from "./statistics-view.vue?vue&type=script&lang=ts"
export * from "./statistics-view.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports